type OptionBadgeProps = {
  count: number;
};

export const OptionBadge = ({ count }: OptionBadgeProps) => {
  if (count <= 0) return null;

  return (
    <span className="flex items-center justify-center h-4.5 min-w-4.5 px-1 py-0.5 bg-text/interactive rounded-small">
      <p className="body-small-semibold text-background/primary">{count}</p>
    </span>
  );
};
